import { render, staticRenderFns } from "./MostPopularStrategies.vue?vue&type=template&id=26bfb676"
import script from "./MostPopularStrategies.vue?vue&type=script&lang=js"
export * from "./MostPopularStrategies.vue?vue&type=script&lang=js"
import style0 from "./MostPopularStrategies.vue?vue&type=style&index=0&id=26bfb676&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports